<template>
  <ContactsTab />
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapState, mapGetters } from 'vuex'
// Components
import ContactsTab from '@/reusable/contacts-tab/ContactsTab'

export default {
  components: {
    ContactsTab
  },

  props: {
    id: [Number, String] // from route
  },

  provide() {
    return {
      provider: this.vendor,
      mainAddress: this.mainAddress
    }
  },

  computed: {
    ...mapState('vendor-show', ['vendor']),
    ...mapGetters('vendor-show', ['mainAddress'])
  }
}
</script>
